<template>
  <form @submit.prevent class="login-form-box login-pagegap confirm-password">
    <div class="logo-img">
      <v-img
        max-height="60"
        max-width="230"
        :src="image_logo"
        :lazy-src="image_logo"
      >
      </v-img>
    </div>
    <h4 class="welcome-text">Reset Password</h4>
    <p>We have send a varification code to registered email. The code is valid for 5 minutes only.</p><br>
    <v-row>
      <v-col>
        <v-text-field 
          class=""
          v-model="code"
          :error-messages="codeErrors"
          label="OTP*"
          required
          @input="$v.code.$touch()"
          @blur="$v.code.$touch()"
          @keypress="updateValue($event,code)"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
      class="relative col passwordbox"
      >
        <v-text-field
            :type="show_new_password ? 'text' : 'password'"
             v-model="new_password"
             autocomplete="new-password"
             :error-messages="passwordErrors"
             label="New Password*"
             :append-icon="show_new_password ? 'mdi-eye' : 'mdi-eye-off'"
             @input="$v.new_password.$touch()"
             @blur="$v.new_password.$touch()"
             @click:append="show_new_password = !show_new_password"
             placeholder="New Password"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
      class="relative col passwordbox confirm-password-input"
      >
        <v-text-field
            :type="confirm_new_password_type ? 'text' : 'password'"
             v-model="confirm_new_password"
             :error-messages="confirmNewErrors"
             label="Confirm New Password*"
             :append-icon="confirm_new_password_type ? 'mdi-eye' : 'mdi-eye-off'"
             @input="$v.confirm_new_password.$touch()"
             @blur="$v.confirm_new_password.$touch()"
             @click:append="confirm_new_password_type = !confirm_new_password_type"
             placeholder="New Password"
        ></v-text-field>
      </v-col>
    </v-row>
      <span v-bind:class="{'error-messagebox-login': isAddClassServerError}" id="server_side_error">{{serverError}}</span>
    <v-row>
      <v-col>
        <v-btn
          class="blue-btn btn"
          @click="submit"
          :disabled="!isFormValid" :error-messages="buttonErrorMessage"
        >
          Reset Password
        </v-btn>
    </v-col>
    </v-row>
    <v-row>
      <v-col>
          <v-btn @click="backtologin" class="back-link">
            Back to login
          </v-btn>
      </v-col>
    </v-row>
  </form>
</template>

<script>
    import axios from 'axios';
    import { validationMixin } from 'vuelidate'
    import { required, email, minLength, sameAs, isAlphanumeric, sameAsPassword, maxLength } from "vuelidate/lib/validators";
    import { Auth } from 'aws-amplify';
    import JwtService from ".././common/jwt.service";

  export default {
    mixins: [validationMixin],

    validations: {
      code:  {required,minLength:minLength(6),maxLength: maxLength(6)},
      new_password: { 
      required,
      minLength: minLength(8),
      validateString: function(value) {
        const containsUppercase = /[A-Z]/.test(value)
        const containsLowercase = /[a-z]/.test(value)
        const containsNumber    = /[0-9]/.test(value)
        const containsSpecial   = /[#?!@$%^&*-]/.test(value)
        return containsUppercase && containsLowercase && containsNumber && containsSpecial
      } 
    },
    confirm_new_password:{ required, sameAsPassword: sameAs('new_password')},
    },

    data: () => ({
      new_password: '',
      code:'',
      submitted:false,
      show_new_password:false,
      serverError:'',
      confirm_new_password:'',
      confirm_new_password_type:false,
      isFormValid:false,
      isAddClassServerError:false,
      image_logo:process.env.VUE_APP_ROOT_ICONS_URL + 'Logo.png',
    }),

    computed: {
      codeErrors () {
        const errors = []
          this.serverError='';
          if (!this.$v.code.$dirty) return errors
          !this.$v.code.required && errors.push('OTP is required')
          !this.$v.code.minLength && errors.push('OTP must be at least 6 characters.')
          !this.$v.code.maxLength && errors.push('OTP may not be greater than 6 characters.')
          return errors
      },
      passwordErrors () {
        const errors = [];
        this.serverError='';
        if (!this.$v.new_password.$dirty) return errors;
        !this.$v.new_password.required && errors.push("Password is required.");
        !this.$v.new_password.minLength && errors.push("Password must be at least 8 characters.");
        !this.$v.new_password.validateString && errors.push("Password must contain one alphabet, one uppercase, one lowecase, one number and one special character.");
      return errors;
      },
      confirmNewErrors(){
        const errors = [];
        this.serverError='';
        if (!this.$v.confirm_new_password.$dirty) return errors;
        !this.$v.confirm_new_password.required && errors.push("Confirm New Password is required.");
        this.$v.confirm_new_password.required && !this.$v.confirm_new_password.sameAsPassword  && errors.push("Confirm New password must match with password.");
        return errors;
      },
      buttonErrorMessage(){
      if (this.$v.$invalid) {
          this.isFormValid = false;
        }else{
          this.isFormValid = true;
        }
    }
    },

     methods: {
      setPassword(value) {
        this.submitted = true;
        this.$v.user.password.$touch();
      },
      submit(e) {
        this.submitted = true;
        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }
        this.$loading(true)
        // const username = localStorage.getItem("username");
        const email = this.authUser.email;
        const code = this.code;
        const new_password = this.new_password;
        Auth.forgotPasswordSubmit(email, code, new_password)
        .then(data => {
          var data = JSON.stringify({"email":email, "name":"", "mobile_no":"", "type":"forget_password"});
         var config = {
            method: 'post',
            url: process.env.VUE_APP_ROOT_API + 'change-password-notification',
            headers: {
            'Content-Type': 'application/json'
            },
            data : data
          };
          //axios(config)
          axios(config).then((response) => {
              swal.fire({
              title: '',
              text: "Password updated successfully",
              icon: 'success',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              //cancelButtonColor: '#d33',
              confirmButtonText: 'OK',
              //cancelButtonText:'No'
            }).then((result) => {
        
            })
          })
          .catch((error) => {
            this.$loading(false);
          });
          this.$loading(false)
          this.$router.push({ name: 'Login' }).catch(()=>{});
        })
        .catch((error) => {
          this.isAddClassServerError = true;
           this.serverError = error.message;
           this.$loading(false);
        });
      },
      backtologin(evt){
      evt.preventDefault();
      this.$router.push({ name: 'Login' }).catch(()=>{});
    },
    updateValue ($event,limitLength) {
    var keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if (limitLength.length > 5) {
         $event.preventDefault();
      }
    },
    }
  }
</script>